import { collection, getDocs, query, where } from "firebase/firestore/lite";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { formatDate } from "./FetchArticle";
import db from "../../Components/firebase.config";
import Partnerwith from "../../../images/Blogs/Partnerwith.png"; // Make sure image exists

function PanleBlog() {
  const { blogsName } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    const getBlogData = async () => {
      try {
        const addArticleCollection = collection(db, "GroupAddArticles");
        const q = query(addArticleCollection, where("route", "==", blogsName));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          const firebaseData = querySnapshot.docs[0].data();
          setData({
            route: firebaseData.route,
            title: firebaseData.title,
            subTitle: firebaseData.subTitle,
            date: firebaseData.date,
            innerImage: firebaseData.InnerImage,
            imageSource: firebaseData.imageSource,
            description: firebaseData.description,
            seotitle: firebaseData.seotitle,
            seoDescription: firebaseData.seoDescription,
            seoKeywords: firebaseData.seoKeywords,
          });
        } else {
          setData(null);
        }
      } catch (error) {
        console.error("Error fetching blog:", error);
        setData(null);
      }
    };

    getBlogData();
  }, [blogsName]);

  const articleURL = `https://senwellsys.com/blogs/${blogsName}`;

  const goToContact = () => {
    window.location.href = "/contact";
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{data ? data.seotitle : "Blog Not Found"}</title>
        <link rel="canonical" href={articleURL} />
        <meta
          name="description"
          content={
            data ? data.seoDescription?.substring(0, 155) : "Blog not found"
          }
        />
        <meta name="keywords" content={data ? data.seoKeywords : ""} />
      </Helmet>
      <section className="news-container">
        {data ? (
          <div className="news-container">
            <h1
              style={{
                fontWeight: "600",
                paddingTop: "77px",
                marginTop: "4%",
                color: "#054776",
              }}
            >
              {data.title}
            </h1>
            <p className="blog-container-date pb-1">
              | {formatDate(data.date)} |
            </p>

            <img src={data.innerImage} alt={data.title} className="bannerimg" />

            {data.imageSource && (
              <p
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "flex-end",
                }}
              >
                Image Source - {data.imageSource}
              </p>
            )}
            {data.subTitle && (
              <h1
                style={{
                  textAlign: "start",
                  fontSize: "1.75rem",
                  fontWeight: "600",
                  margin:"1.5rem 0 15px"
                }}
              >
                {data.subTitle}
              </h1>
            )}
            <p
              dangerouslySetInnerHTML={{ __html: data.description }}
              className="EventText"
              style={{ backgroundColor: "white" }}
            />
            <div className="container">
              <img
                src={Partnerwith}
                alt="HireDeveloper"
                className="HireDev"
                title="contact us"
                onClick={goToContact}
              />
            </div>
          </div>
        ) : (
          <p style={{ padding: "100px", textAlign: "center" }}>Loading...</p>
        )}
      </section>
    </>
  );
}

export default PanleBlog;
